import { useQuery } from "@apollo/client";
import { ProfileProfessionView } from "./profile-profession-view";
import { ApplicantProfileProfessionViewContainerApplicantUserDocument, ApplicantProfileProfessionViewContainerApplicantUserFieldsFragment } from "../../../../generated";
import { Empty } from "antd";
import { useNavigate } from "react-router-dom";
import { lookupCountryQuery } from "./profile-profession-country-query";
import { ComponentQueryLoader } from "../../../shared/component-query-loader";
import { Country } from "../../../../types/country";

interface ProfileProfessionViewContainerProps {
  data: {
    applicantId: string;
  };
}

export const ProfileProfessionViewContainer: React.FC<ProfileProfessionViewContainerProps> = (props) => {
  const navigate = useNavigate();

  const {
    data: professionData,
    loading: professionLoading,
    error: professionError,
  } = useQuery(ApplicantProfileProfessionViewContainerApplicantUserDocument, {
    variables: {
      applicantUserId: props.data.applicantId,
    },
  });

  const {
    data: countryData,
    error: countryError,
    loading: countryLoading,
  } = useQuery(lookupCountryQuery);

  const handleEditToggle = () => {
    navigate(location.pathname.replace(/\/[^/]+$/, "/edit"));
  };

  return (
    <ComponentQueryLoader
      loading={countryLoading || professionLoading}
      error={countryError || professionError}
      hasData={!!professionData && !!countryData}
      hasDataComponent={
        <ProfileProfessionView 
          data={professionData?.applicantUser as ApplicantProfileProfessionViewContainerApplicantUserFieldsFragment} 
          countryData={countryData?.countries?.eventPayload?.countries as Country[]}
          onEdit={handleEditToggle} 
        />
      }
      noDataComponent={<Empty description="No data available" />}
    />
  );
};
